var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "action-pane-wrapper", attrs: { id: "checklist-tab" } },
    [
      _c("form", {
        attrs: { id: "checklist-form", autocomplete: "off" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            $event.stopPropagation()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "h-100 d-flex", attrs: { id: "checklist-input" } },
        [
          _c(
            "div",
            { staticClass: "w-100" },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c(
                    "simple-button",
                    {
                      attrs: { disabled: _vm.loading },
                      on: { click: _vm.showTemplateEditor },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("boards.actions.selectTemplate")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("checklist-component", {
                attrs: { title: _vm.title, checklist: _vm.checklist },
                on: { input: _vm.handleUpdate },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "dropdown h-100 d-flex justify-content-end" }, [
        _c(
          "button",
          {
            ref: "submitChecklist",
            staticClass:
              "btn btn-primary clickable btn-sm submit-changes checklist-tab",
            class: { "dropdown-toggle": !_vm.external },
            attrs: {
              role: "button",
              "data-toggle": _vm.external ? null : "dropdown",
              "aria-haspopup": "true",
              "aria-expanded": "false",
              type: "button",
              disabled: !_vm.checklist.length || _vm.loading,
            },
            on: {
              click: _vm.handleSubmitClick,
              dblclick: function ($event) {
                $event.stopPropagation()
                return _vm.handleSubmit(false)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("global.words.save")) + "\n    ")]
        ),
        _vm._v(" "),
        !_vm.external
          ? _c(
              "div",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "dropdownMenuLink" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item clickable",
                    on: {
                      click: function ($event) {
                        return _vm.handleSubmit(false)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("client-profile.actions.saveChecklist")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-divider" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "dropdown-item clickable",
                    attrs: { type: "button", disabled: !_vm.isUniqueName },
                    on: {
                      click: function ($event) {
                        return _vm.handleSubmit(true)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "client-profile.actions.saveChecklistAndTemplate"
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("checklist-template-editor", {
        ref: "checklistTemplateEditor",
        attrs: {
          "checklist-templates": _vm.templates,
          "initial-template": { title: _vm.title, checklist: _vm.checklist },
          loading: _vm.loading,
        },
        on: {
          select: _vm.handleTemplateSelect,
          delete: _vm.handleTemplateDelete,
          add: _vm.handleAddTemplate,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }